@if (orientation === 'horizontal') {
<!-- The severities as columns, least severe first, like the Network Policy table on the listing. -->
<table class="olf olf--horizontal" [attr.aria-label]="label" [id]="idPrefix">
    <thead>
        <tr>
            @for (rung of rungs; track rung.key) {
            <th scope="col" class="olf__rung" [attr.data-sev]="rung.severity">
                <label class="olf__sev" [class.olf__sev--invalid]="!!errorFor(rung)" [for]="idPrefix + rung.label">{{
                    rung.label
                }}</label>
            </th>
            }
        </tr>
    </thead>
    <tbody>
        <tr>
            @for (rung of rungs; track rung.key) {
            <td>
                <ng-container *ngTemplateOutlet="box; context: { $implicit: rung }"></ng-container>
            </td>
            }
        </tr>
    </tbody>
</table>
} @else {
<!-- One row per severity, least severe first, so the ladder reads top to bottom in the order a component reaches it. -->
<table class="olf" [attr.aria-label]="label" [id]="idPrefix">
    <thead>
        <tr>
            <th scope="col">Severity</th>
            <th scope="col">Offline for</th>
        </tr>
    </thead>
    <tbody>
        @for (rung of rungs; track rung.key) {
        <tr class="olf__rung" [attr.data-sev]="rung.severity">
            <th scope="row">
                <label class="olf__sev" [class.olf__sev--invalid]="!!errorFor(rung)" [for]="idPrefix + rung.label">{{
                    rung.label
                }}</label>
            </th>
            <td>
                <ng-container *ngTemplateOutlet="box; context: { $implicit: rung }"></ng-container>
            </td>
        </tr>
        }
    </tbody>
</table>
}

<ng-template #box let-rung>
    <app-duration-input
        [inputId]="idPrefix + rung.label"
        [label]="orientation === 'horizontal' ? rung.label : ''"
        [compact]="orientation === 'horizontal'"
        [value]="ladder?.[rung.key]"
        [placeholder]="placeholders[rung.key] || 'Not set'"
        [invalid]="allInvalid || !!errorFor(rung)"
        [disabled]="disabled"
        (valueChange)="setRung(rung, $event)"
        (invalidChange)="setInvalid(rung, $event)"
        (blurred)="rungBlur.emit(rung.key)"
    ></app-duration-input>
    @if (errorFor(rung)) {
    <p class="olf__error" [id]="idPrefix + rung.label + 'Error'" role="alert">{{ errorFor(rung) }}</p>
    }
</ng-template>
